import { useNavigate, useParams } from "react-router-dom";
import { useGetNewById } from "../../services/newService";
import { ROUTES } from "../../../../routes/routes";

export const useNewDetailPage = () => {
  const { newId } = useParams<{ newId: string }>();
  const {
    data: newData,
    isLoading: isLoadingNewData,
    isError: isErrorNewData,
  } = useGetNewById(newId || "");
  const navigate = useNavigate();
  
  const handleNavigateToDashboard = () => {
    navigate(`${ROUTES.DASHBOARD.LIFEGUARD}?tab=novedades`);
  };

  return {
    newData,
    isLoading: isLoadingNewData,
    isErrorNewData,
    handleNavigateToDashboard,
  };
};
